// This import cannot be shortened without creating circular dependencies.
import { HumanAssistedResolutionNodeModelForm } from '@app/page-components/app/canvas/node-forms';
import {
  DesignModuleNodeProps,
  HumanAssistedResolutionObjectConfig,
  IconClass,
  NodeTypeName
} from '@app/types';
import BaseNodeModel from '../BaseNodeModel';

/** Delegate handling to Process Engine's Human Assisted Resolution feature. */
export class HumanAssistedResolutionNodeModel extends BaseNodeModel<HumanAssistedResolutionObjectConfig> {
  constructor(
    nodeName = 'UNTITLED_NODE',
    x = 0,
    y = 0,
    props: DesignModuleNodeProps<HumanAssistedResolutionObjectConfig> | null = null,
    id = null
  ) {
    super(nodeName, x, y, null, id);
    this.props.nodeTypeName = NodeTypeName.humanAssistedResolution;
    this.props.iconClass = IconClass.share2;
    this.props.colorClass = 'goldenrod';
    this.DEFAULT_COLOR_CLASS = 'goldenrod';
    this.applyProps(props);
  }

  getConfigViews() {
    return [
      <HumanAssistedResolutionNodeModelForm key="form" object={this} />
    ];
  }
}
